import React from 'react'

import { Stack, Typography, Box, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { WarningAmberOutlined } from '@mui/icons-material'

import { ChargingStepProps } from '../hooks/useStartCharging/types'
import { ChargingStepActions } from '../components/ChargingStepActions'
import { numericUtils } from '@/utils/numeric'

export const PendingBalanceStep: React.FC<ChargingStepProps> = ({ startChargingMethods }) => {
  const { pendingBalance, goForward, cancel } = startChargingMethods

  return (
    <>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <WarningAmberOutlined color="warning" />
          <Typography variant="h6" fontWeight="bold">
            Saldo pendente
          </Typography>
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={3}>
          <Typography variant="body1" color="text.secondary">
            Você possui um valor pendente por ociosidade na última sessão que deve ser quitado antes de iniciar o
            carregamento.
          </Typography>

          <Box
            sx={{
              backgroundColor: 'warning.light',
              borderRadius: 2,
              padding: 2,
            }}
          >
            <Stack direction="column" alignItems="center" spacing={1}>
              <Typography variant="body2" color="warning.contrastText">
                Valor pendente:
              </Typography>
              <Typography variant="h5" fontWeight="bold" color="warning.contrastText">
                {numericUtils.formatNumberToBRLCurrency(Math.abs(pendingBalance))}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </DialogContent>

      <DialogActions>
        <ChargingStepActions sx={{ width: '100%' }}>
          <ChargingStepActions.ForwardButton onClick={goForward} />
          <ChargingStepActions.BackwardButton onClick={cancel} />
        </ChargingStepActions>
      </DialogActions>
    </>
  )
}
